import type { CustomerCurrency } from '@/config/currency';

export interface ITourDetails {
  tourId: string;
  year: string;
  month: string;
  day: string;
  time: string;
  adults: string;
  children: string;
  infants: string;
  currency: CustomerCurrency;
}

export const QUERY_KEYS = {
  cancellation: (tourId: string) => ['cancellation', tourId],
  /** Homepage combo carousels — amounts vary with X-Currency. */
  combo: (currency: CustomerCurrency) => ['combo', currency],
  contact: () => ['contact'],
  countries: (adventureId: string = '0') => ['countries', adventureId],
  /** Public tour search/grid — amounts vary with X-Currency. */
  tourSearch: (currency: CustomerCurrency, bodyKey: string) => ['tourSearch', currency, bodyKey],
  /** Tour detail catalog prices (From / rates / pickup) — amounts vary with X-Currency. */
  tourDetailsPrice: (tourId: string, currency: CustomerCurrency) => [
    'tourDetailsPrice',
    tourId,
    currency,
  ],
  draftAbout: (draftId: string) => ['about', draftId],
  draftAnimals: (draftId: string) => ['animals-to-see', draftId],
  draftCancellation: (draftId: string) => ['cancellation', draftId],
  draftCommissions: (draftId: string) => ['commissions', draftId],
  draftLanguages: (draftId: string) => ['languages', draftId],
  draftLocation: (draftId: string) => ['location', draftId],
  draftFeatures: (draftId: string) => ['features', draftId],
  draftPhotos: (draftId: string) => ['photos', draftId],
  draftPreview: (draftId: string, currency: CustomerCurrency) => ['preview', draftId, currency],
  draftSchedulePrice: (draftId: string) => ['schedule-price', draftId],
  myBookings: () => ['my-bookings'],
  places: () => ['places'],
  myTours: (currency: CustomerCurrency) => ['my-tours', currency],
  userName: () => ['user-name'],
  tourOperator: () => ['tour-operator'],
  tourDetails: ({ tourId, year, month, day, time, adults, children, infants, currency }: ITourDetails) => [
    'tourDetails',
    tourId,
    year,
    month,
    day,
    time,
    adults,
    children,
    infants,
    currency,
  ],
  tourPrice: ({
    tourId,
    year,
    month,
    day,
    adults,
    children,
    infants,
    currency,
  }: Omit<ITourDetails, 'time'>) => [
    'tourPrice',
    tourId,
    year,
    month,
    day,
    adults,
    children,
    infants,
    currency,
  ],
  // Reservation payment info is currency-snapshotted server-side; do not key by customer currency.
  tourReservation: (resId: string) => ['reservation', resId],
};
